import React from 'react';
import styled from 'styled-components';
import { Spinner2 } from '@styled-icons/icomoon/Spinner2';

const Container = styled.div`
    animation: .7s linear 0s normal none infinite running rotate;
    width: 50px;
    svg {
        fill: #f54d2e;
    }
    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

export default () =>
    <Container>
        <Spinner2 size={50} color='#29d' />
    </Container>;

const Spinner = styled.svg`
    animation: rotator 1.4s linear infinite;

    @keyframes rotator {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(270deg); }
    }

    @keyframes dash {
        0% {
            stroke-dashoffset: 187;
        }
        50% {
            stroke-dashoffset: 46.75;
            transform: rotate(135deg);
        }
        100% {
            stroke-dashoffset: 187;
            transform: rotate(450deg);
        }
    }

    circle {
        stroke-dasharray: 187;
        stroke-dashoffset: 0;
        transform-origin: center;
        animation: dash 1.4s ease-in-out infinite;
        stroke: var(--primary);
    }
`;

export const ButtonLoader = ({ children, loading }) =>
    loading ?
        <div style={{ display: 'flex' }}>
            <Spinner width="20px" height="20px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle fill="none" strokeWidth="6" style={{ stroke: "rgb(108, 108, 108)" }} strokeLinecap="round" cx="33" cy="33" r="30"></circle>
            </Spinner>
            <div style={{ margin: 0, marginLeft: 15 }}>{ children }</div>
        </div> :
        children;
